import ReduxFormModal from './ReduxFormModalContainer';

export default ReduxFormModal;
